module.exports = __webpack_public_path__ + "img/nav0h.ffa60972.png";